import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from '../layout/AppShell';
import AuthPage from '../pages/AuthPage';
import InteractiveEmbedGallery from '../components/chat/embeds/InteractiveEmbedGallery';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ProtectedRoute from './ProtectedRoute';
import PublicOnlyRoute from './PublicOnlyRoute';
import RootRedirect from './RootRedirect';
import { APP_ROUTES, AUTH_ROUTES } from './routingContract';

function ProtectedAppShell() {
  return (
    <ProtectedRoute>
      <AppShell />
    </ProtectedRoute>
  );
}

const showEmbedFixtures = process.env.NODE_ENV !== 'production';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route
        path={AUTH_ROUTES.signIn}
        element={(
          <PublicOnlyRoute>
            <AuthPage mode="login" />
          </PublicOnlyRoute>
        )}
      />
      <Route
        path={AUTH_ROUTES.createAccount}
        element={(
          <PublicOnlyRoute>
            <AuthPage mode="signup" />
          </PublicOnlyRoute>
        )}
      />
      <Route
        path={AUTH_ROUTES.forgotPassword}
        element={(
          <PublicOnlyRoute>
            <ForgotPasswordPage />
          </PublicOnlyRoute>
        )}
      />
      {showEmbedFixtures && <Route path="/__embed-fixtures" element={<InteractiveEmbedGallery />} />}
      <Route path={APP_ROUTES.root} element={<Navigate to={APP_ROUTES.dashboard} replace />} />
      <Route path="/app/*" element={<ProtectedAppShell />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
